var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import MatchGroup from './MatchGroup';
import { matchStartDateSortFunc } from '../../../rendering-commons/Sorting';
var League = function (props) {
    var leagueMatchesIds = props.league.get('matches');
    var leagueMatches = leagueMatchesIds.map(function (m) { return props.matches.get(m); });
    var filteredMatches = leagueMatches;
    if (leagueMatches.size === 0) {
        return false;
    }
    var matchProps = {
        section: props.section,
        leagueName: props.league.get('name'),
        sportCssName: props.sportCssName,
        matches: props.matches,
        languageId: props.languageId
    };
    var timezone = moment.tz.guess();
    var sortedMatches = filteredMatches.sort(matchStartDateSortFunc).groupBy(function (m) { return m.get('startDate').tz(timezone).format('MM-DD-YYYY'); });
    var matchGroups = [];
    var i = 0;
    sortedMatches.forEach(function (dateMatches, mdate) {
        var matchArray = dateMatches.map(function (m) { return m.get('id'); }).toArray();
        matchGroups.push(_jsx(MatchGroup, __assign({ mdate: mdate, matchIds: matchArray }, matchProps), ++i));
    });
    return matchGroups;
};
League.propTypes = {
    league: PropTypes.object.isRequired,
    sportCssName: PropTypes.string.isRequired,
    matches: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired
};
function mapStateToProps(state, props) {
    var section = props.section;
    var matches = state.application.getIn([section, 'matches']);
    var languageId = state.application.get('languageId');
    return {
        matches: matches,
        languageId: languageId
    };
}
League = connect(mapStateToProps)(League);
export default League;



// WEBPACK FOOTER //
// ./src/components/info/results/League.jsx